import React from "react";
var __jsx = React.createElement;
import SearchBlade from './SearchBlade';
function SearchBladeAdapter(_ref) {
  var data = _ref.data;
  return __jsx(SearchBlade, {
    path: data.path
  });
}
export default SearchBladeAdapter;